export const permissionValues = ['view', 'edit', 'manage', 'admin'];
